<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Building a WWII Jeep</h1>
<h1 class="title1">Finding, Restoring, and Rebuilding a Wartime Legend</h1>
<p class="author">Sean Dunnage</p>
<div class="img_container1">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?07a6fa45